module.exports = __webpack_public_path__ + "img/logo.21fbd57a.png";